import { ColorType, VariantClassesProps } from '../../utils'
import { TextSize, TextVariant } from './Text.types'

/** Size styles controller */
export const getSizeClasses = (size: TextSize): string => {
    const sizeClasses: VariantClassesProps = {
        xs: 'text-3xs',
        sm: 'text-2xs',
        base: 'text-xs',
        md: 'text-xs',
        lg: 'text-sm',
        default: 'text-md',
        title: 'text-lg',
        tableCell: 'text-2xs',
    }

    return sizeClasses[size] || sizeClasses.md // Default size: md
}

// Variant styles
/** Styles for contained text variant */
export const getContainedClasses = (color: ColorType): string => {
    const colorClasses: VariantClassesProps = {
        primary: 'text-background-base font-black',
        secondary: 'text-background-primary font-black',
        error: 'text-background-base font-black',
        light: 'text-color-title font-black',
        dark: 'text-[hsl(var(--text-muted))] font-black',
        title: 'text-color-title font-black',
        gradient: 'text-background-base font-black',
        tableCell: 'text-color-table-cell font-bold',
        group: 'text-color-title font-black',
    }

    return colorClasses[color] || colorClasses.primary // Default color: primary
}

/** Styles for link text variant */
export const getLinkClasses = (color: ColorType): string => {
    const colorClasses: VariantClassesProps = {
        primary: 'text-blue-500 font-black',
        secondary: 'text-background-primary font-black',
        error: 'text-color-error font-black',
        light: 'text-color-title font-black',
        dark: 'text-[hsl(var(--text-muted))] font-black',
        title: 'text-color-title font-black',
        gradient: '!text-background-primary font-black',
        tableCell: '!text-color-table-cell !font-bold',
    }

    return colorClasses[color] || colorClasses.primary // Default color: primary
}
/** Styles for description text variant */
export const getDescriptionClasses = (color: ColorType): string => {
    const colorClasses: VariantClassesProps = {
        primary: 'text-blue-500 font-black',
        secondary: 'text-background-primary font-black',
        error: 'text-color-error font-normal',
        light: 'text-color-title font-black',
        dark: 'text-[hsl(var(--text-muted))] font-black',
        title: 'text-color-title font-black',
        description: 'text-color-title font-normal',
        gradient: '!text-background-primary font-black',
        tableCell: '!text-color-table-cell !font-bold',
    }

    return colorClasses[color] || colorClasses.primary // Default color: primary
}

export const getTitleClasses = (color: ColorType): string => {
    const colorClasses: VariantClassesProps = {
        primary:
            'text-background font-bold text-lg font-secondary text-background-hover-secondary',
        secondary: 'text-background-primary font-bold text-lg',
        error: 'color-color-error font-bold text-lg',
        light: 'text-color-title font-bold text-lg',
        dark: 'text-[hsl(var(--text-muted))] font-bold text-lg',
        title: 'text-color-title font-black',
        gradient: 'text-background-base font-bold text-lg',
        tableCell: 'text-color-table-cell font-bold',
    }

    return colorClasses[color] || colorClasses.primary // Default color: primary
}

/** Variant styles controller */
export const getVariantClasses = (
    color: ColorType,
    variant: TextVariant
): string => {
    const variantClasses: VariantClassesProps = {
        link: getLinkClasses(color),
        text: getLinkClasses(color),
        description: getDescriptionClasses(color),
        title: getTitleClasses(color),
        contained: getContainedClasses(color),
        tableCell: getTitleClasses(color),
    }

    return variantClasses[variant] || variantClasses.contained // Default variant: contained
}
